import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    wxConfig: null

  },
  mutations: {
    SET_WXCONFIG(state, data) {
      state.wxConfig = data;
    }

  },
  actions: {

  }
})
